import { render, staticRenderFns } from "./PosBills.vue?vue&type=template&id=a0d4db92&"
import script from "./PosBills.vue?vue&type=script&lang=js&"
export * from "./PosBills.vue?vue&type=script&lang=js&"
import style0 from "./PosBills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports